export class Company {
    id: number;
    name: string;
    Email: string;
    Contacts: string;
    nif: string;
    address: string;
    plataformName: string;
    prefix: string;
    alvara: string; 
    companyTypeName: string;
    companyTypeId: number;
    highlighted: any;
}
 
